function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useCallback, useState, useRef, useEffect, useMemo } from 'react';
import classNames from 'classnames';
import { LoadingOverlay, SearchInput, SelectValueList } from '@deephaven/components';
import { EMPTY_FUNCTION, PromiseUtils } from '@deephaven/utils';
import Log from '@deephaven/log';
import { Formatter, FormatterUtils } from '@deephaven/jsapi-utils';
import { useApi } from '@deephaven/jsapi-bootstrap';
import useTableColumn from "./useTableColumn.js";
import "./TableInput.css";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var log = Log.module('TableInput');
var SIZE_LIMIT = 250;
function TableInput(props) {
  var _table$size, _error$message;
  var _props$className = props.className,
    className = _props$className === void 0 ? undefined : _props$className,
    columnName = props.columnName,
    settings = props.settings,
    _props$defaultValue = props.defaultValue,
    defaultValue = _props$defaultValue === void 0 ? [] : _props$defaultValue,
    _props$isInvalid = props.isInvalid,
    isInvalid = _props$isInvalid === void 0 ? false : _props$isInvalid,
    _props$onChange = props.onChange,
    onChange = _props$onChange === void 0 ? EMPTY_FUNCTION : _props$onChange,
    _props$onBlur = props.onBlur,
    onBlur = _props$onBlur === void 0 ? EMPTY_FUNCTION : _props$onBlur,
    tablePromise = props.table;
  var parentRef = useRef(null);
  var dh = useApi();
  var formatter = useMemo(() => {
    var columnFormats = FormatterUtils.getColumnFormats(settings);
    var dateTimeFormatterOptions = FormatterUtils.getDateTimeFormatterOptions(settings);
    var _settings$defaultDeci = settings.defaultDecimalFormatOptions,
      defaultDecimalFormatOptions = _settings$defaultDeci === void 0 ? {} : _settings$defaultDeci,
      _settings$defaultInte = settings.defaultIntegerFormatOptions,
      defaultIntegerFormatOptions = _settings$defaultInte === void 0 ? {} : _settings$defaultInte;
    return new Formatter(dh, columnFormats, dateTimeFormatterOptions, defaultDecimalFormatOptions, defaultIntegerFormatOptions);
  }, [dh, settings]);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var _useState3 = useState(new Set(defaultValue)),
    _useState4 = _slicedToArray(_useState3, 2),
    selection = _useState4[0],
    setSelection = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    table = _useState6[0],
    setTable = _useState6[1];
  var listRef = useRef(null);
  var itemCount = Math.min((_table$size = table === null || table === void 0 ? void 0 : table.size) !== null && _table$size !== void 0 ? _table$size : 0, SIZE_LIMIT);
  var _useTableColumn = useTableColumn(table, 0, SIZE_LIMIT - 1, columnName),
    column = _useTableColumn.column,
    data = _useTableColumn.data,
    error = _useTableColumn.error;
  var formatValue = useCallback(value => column ? formatter.getFormattedString(value, column.type, column.name) : "".concat(value), [column, formatter]);
  var _useMemo = useMemo(() => {
      var removedItems = new Set(selection);
      var result = [];
      if (data == null) {
        // Viewport not initialized
        return [result, null];
      }
      data.forEach(v => {
        var value = "".concat(v);
        var isSelected = selection.has(value);
        if (isSelected) {
          removedItems.delete(value);
        }
        result.push({
          value,
          displayValue: formatValue(v),
          isSelected
        });
      });
      if (removedItems.size > 0) {
        log.debug2('Selection has items that are missing from the viewport');
        var newSelection = new Set(selection);
        Array.from(removedItems).forEach(value => {
          newSelection.delete(value);
        });
        return [result, newSelection];
      }
      return [result, null];
    }, [data, selection, formatValue]),
    _useMemo2 = _slicedToArray(_useMemo, 2),
    items = _useMemo2[0],
    updatedSelection = _useMemo2[1];
  useEffect(() => {
    if (updatedSelection !== null) {
      setSelection(updatedSelection);
      onChange(Array.from(updatedSelection));
    }
  }, [onChange, updatedSelection]);
  var initTable = useCallback(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (promise) {
      try {
        var resolved = yield promise;
        log.debug('Table resolved', resolved);
        setTable(resolved);
      } catch (e) {
        if (PromiseUtils.isCanceled(e)) {
          return;
        }
        log.error(e);
      }
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), []);
  useEffect(() => {
    var cancelablePromise = PromiseUtils.makeCancelable(tablePromise);
    initTable(cancelablePromise);
    return () => {
      log.debug2('Cancel table promise');
      cancelablePromise.cancel();
    };
  }, [tablePromise, initTable]);

  // Scroll the item matching the input into view
  var handleSearchChange = useCallback(e => {
    var value = e.target.value;
    setSearchValue(value);
    var index = items.findIndex(item => item.displayValue.includes(value));
    if (index > -1) {
      var _listRef$current;
      log.debug2("Found ".concat(value, " at index ").concat(index));
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollIntoView(index);
    } else {
      log.debug2("".concat(value, " not found"));
    }
  }, [items, listRef]);
  var handleSelect = useCallback(index => {
    log.debug('handleSelect', index);
    if (index >= items.length) {
      log.error('Invalid index', index);
      return;
    }
    var selectedValue = items[index].value;
    var newSelection = new Set(selection);
    if (items[index].isSelected) {
      newSelection.delete(selectedValue);
    } else {
      newSelection.add(selectedValue);
    }
    setSelection(newSelection);
    onChange(Array.from(newSelection));
  }, [onChange, items, selection]);
  var handleSelectAll = useCallback(() => {
    var values = items.map(item => item.value);
    var newSelection = new Set(values);
    setSelection(newSelection);
    onChange(values);
  }, [items, onChange]);
  var handleClearSelection = useCallback(() => {
    setSelection(new Set());
    onChange([]);
  }, [onChange]);
  var handleViewportChange = useCallback(() => {
    // no-op
  }, []);
  var handleChildBlur = useCallback(e => {
    var _parentRef$current;
    var relatedTarget = e.relatedTarget;
    log.debug('handleChildBlur', relatedTarget, relatedTarget instanceof HTMLElement, parentRef.current, (_parentRef$current = parentRef.current) === null || _parentRef$current === void 0 ? void 0 : _parentRef$current.contains(relatedTarget));
    if (!relatedTarget || parentRef.current && relatedTarget instanceof HTMLElement && !parentRef.current.contains(relatedTarget)) {
      onBlur();
    }
  }, [onBlur]);
  var isEmpty = items.length === 0;
  return /*#__PURE__*/_jsxs("div", {
    ref: parentRef,
    className: classNames('table-input-container d-flex flex-column position-relative', className),
    children: [/*#__PURE__*/_jsx(SearchInput, {
      disabled: !!error || isEmpty,
      value: searchValue,
      placeholder: "Search",
      onChange: handleSearchChange,
      className: "mb-2 d-flex",
      onBlur: handleChildBlur
    }), /*#__PURE__*/_jsx(SelectValueList, {
      className: "table-input-list",
      disabled: table === undefined || isEmpty,
      isInvalid: isInvalid,
      items: isEmpty ? [{
        value: 'Empty',
        isSelected: false
      }] : items,
      itemCount: itemCount,
      offset: 0,
      onSelect: handleSelect,
      onViewportChange: handleViewportChange,
      ref: listRef,
      onBlur: handleChildBlur
    }), table && /*#__PURE__*/_jsxs("div", {
      className: "meta-row",
      children: [/*#__PURE__*/_jsx("div", {
        className: "d-flex align-items-center text-muted small",
        children: table != null && table.size > itemCount && /*#__PURE__*/_jsxs(_Fragment, {
          children: ["Table is too large, showing the first ", SIZE_LIMIT, " items."]
        })
      }), /*#__PURE__*/_jsxs("div", {
        children: [/*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn btn-link",
          onBlur: handleChildBlur,
          onClick: handleSelectAll,
          children: "Select All"
        }), /*#__PURE__*/_jsx("button", {
          type: "button",
          className: "btn btn-link mr-a",
          onBlur: handleChildBlur,
          onClick: handleClearSelection,
          children: "Clear"
        })]
      })]
    }), table == null || error && /*#__PURE__*/_jsx("div", {
      className: "h-100 w-100 position-absolute",
      children: /*#__PURE__*/_jsx(LoadingOverlay, {
        isLoaded: table != null,
        isLoading: table == null && error == null,
        errorMessage: (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : null,
        "data-testid": "table-input-loading"
      })
    })]
  });
}
export default TableInput;
//# sourceMappingURL=TableInput.js.map